"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _variables = require("@nerdwallet/base-styles/variables");
var _imageModule = _interopRequireDefault(require("./image.module.css"));
/**
 * Helper used to get the correct percentage to
 * apply to padding-bottom given a supported aspect
 * ratio size. For example, a 5:2 ratio is calculated by
 * dividing 2 by 5 to get 40%.
 *
 * @param {String} aspectRatio. For example, "5:2".
 * @returns {null | String} to be used as the appropriate percentage.
 */
var calculateAspectRatioPercentage = function calculateAspectRatioPercentage(aspectRatio) {
  if (!aspectRatio) {
    return null;
  }

  // Parse numbers out of supplied aspectRatio.
  var values = aspectRatio.toLowerCase().split(':');
  var width = parseFloat(values[0]);
  var height = parseFloat(values[1]);
  var percentage = height / width * 100;

  // Clamp to three decimal points
  return percentage.toFixed(3);
};
var Wrapper = function Wrapper(_ref) {
  var aspectRatio = _ref.aspectRatio,
    backgroundColor = _ref.backgroundColor,
    children = _ref.children,
    className = _ref.className,
    placeholderImage = _ref.placeholderImage;
  var style = {
    backgroundColor: backgroundColor
  };
  if (placeholderImage) {
    style = {
      backgroundImage: "url(\"".concat(placeholderImage, "\")")
    };
  }

  // Conditionally calculate and inline padding-bottom percentage
  // to support an aspect ratio if the prop is supplied
  if (aspectRatio) {
    style.paddingBottom = "".concat(calculateAspectRatioPercentage(aspectRatio), "%");
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_imageModule.default.wrapper, className),
    style: style
  }, children);
};
Wrapper.defaultProps = {
  aspectRatio: null,
  backgroundColor: _variables.colors['neutral-lightest']
};
Wrapper.propTypes = {
  aspectRatio: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  placeholderImage: _propTypes.default.string
};
var _default = Wrapper;
exports.default = _default;